export const orderManagementSteps = {
  boilerMaintenanceStep: 'boilerMaintenanceStep',
  serviceProposalStep: 'serviceProposalStep',
  selectedProductsOverviewStep: 'selectedProductsOverviewStep',
  myEnecoAccountStep: 'myEnecoAccountStep',
  personalDetailsStep: 'personalDetailsStep',
  deliveryAddressStep: 'deliveryAddressStep',
  electricityDetailsStep: 'electricityDetailsStep',
  gasDetailsStep: 'gasDetailsStep',
  selectPaymentMethodStep: 'selectPaymentMethodStep',
  overviewStep: 'overviewStep',
  orderConfirmationStep: 'orderConfirmationStep',
} as const;

export type OrderManagementStep = (typeof orderManagementSteps)[keyof typeof orderManagementSteps];

export const activeHeaderIndexForStep: {
  gridColumnDesktop: '4/10' | '4/13';
  step: OrderManagementStep;
  activeHeaderIndex: number;
}[] = [
  { step: 'boilerMaintenanceStep', activeHeaderIndex: 1, gridColumnDesktop: '4/10' },
  { step: 'serviceProposalStep', activeHeaderIndex: 1, gridColumnDesktop: '4/10' },
  { step: 'selectedProductsOverviewStep', activeHeaderIndex: 1, gridColumnDesktop: '4/10' },
  { step: 'myEnecoAccountStep', activeHeaderIndex: 2, gridColumnDesktop: '4/13' },
  { step: 'personalDetailsStep', activeHeaderIndex: 2, gridColumnDesktop: '4/13' },
  { step: 'deliveryAddressStep', activeHeaderIndex: 3, gridColumnDesktop: '4/13' },
  { step: 'electricityDetailsStep', activeHeaderIndex: 3, gridColumnDesktop: '4/13' },
  { step: 'gasDetailsStep', activeHeaderIndex: 3, gridColumnDesktop: '4/13' },
  { step: 'selectPaymentMethodStep', activeHeaderIndex: 3, gridColumnDesktop: '4/13' },
  { step: 'overviewStep', activeHeaderIndex: 4, gridColumnDesktop: '4/10' },
  { step: 'orderConfirmationStep', activeHeaderIndex: 4, gridColumnDesktop: '4/10' },
];

export type FlowChildProps = {
  nextMainStep: (step?: OrderManagementStep, orderId?: string) => void;
};

interface StepBuilderParams {
  hasSelectedServices: boolean;
  hasSelectedMaintenance: boolean;
  hasSelectedElectricityProduct: boolean;
  hasSelectedGasProduct: boolean;
  isLoggedIn: boolean;
  swapOrder: boolean;
}

export const buildDynamicStepOrder = (params: StepBuilderParams) => {
  const swapOrder = params.swapOrder;
  const steps: OrderManagementStep[] = [];

  // This value will only be true if the user chooses a service product through eneco.be.
  // In that case we still have to show the boiler maintenance screen
  if (swapOrder) {
    steps.push('serviceProposalStep');
    steps.push('boilerMaintenanceStep');
  } else {
    steps.push('boilerMaintenanceStep');
    steps.push('serviceProposalStep');
  }

  if (
    // If there are selected services and either no electricity or no gas products
    (params.hasSelectedServices && (!params.hasSelectedElectricityProduct || !params.hasSelectedGasProduct)) ||
    // If there are no selected services and no commodity products
    (!params.hasSelectedServices && !params.hasSelectedGasProduct && !params.hasSelectedElectricityProduct)
  ) {
    steps.push('selectedProductsOverviewStep');
  }
  if (!params.isLoggedIn) {
    steps.push('myEnecoAccountStep');
  }
  steps.push('personalDetailsStep');
  steps.push('deliveryAddressStep');
  if (params.hasSelectedElectricityProduct) {
    steps.push('electricityDetailsStep');
  }
  if (params.hasSelectedGasProduct || params.hasSelectedMaintenance) {
    steps.push('gasDetailsStep');
  }
  steps.push('selectPaymentMethodStep');
  steps.push('overviewStep');
  steps.push('orderConfirmationStep');
  return steps;
};
